// Dev-only logging helpers. Silenced in production builds so internal
// details never appear in end-user consoles.
export const devWarn = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    console.warn(...args);
  }
};

export const devLog = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    console.log(...args);
  }
};
